/** The client bundle's git SHA (vite.config.js `define`), or "dev" for a local build. */
export const CLIENT_BUILD_SHA =
  typeof __BUILD_SHA__ === "string" && __BUILD_SHA__ ? __BUILD_SHA__ : "dev";
